import { useState } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";

const testimonials = [
  {
    id: 1,
    quote: "She's the best! Sweetest, makes sure you get all the shots you want, does her best to accommodate you even with a busy schedule. She works her butt off to get your photos to you in a short amount of time, and they're absolutely perfect. She took our engagements, wedding photos, maternity, and Christmas photos!",
    author: "Shay",
    type: "Maternity Client",
    image: "https://customer-assets.emergentagent.com/job_relaxed-margulis-6/artifacts/j3mbzqki_311250274_1099753797499620_8911476985132425996_n.jpg",
  },
  {
    id: 2,
    quote: "You made sure our engagements, my bridals, and of course our wedding was everything and more. She made us feel so comfortable, and did everything she could to make sure everything went PERFECT. THANK you Brittany you are greatly appreciated.",
    author: "Shayla",
    type: "Wedding Client",
    image: "https://customer-assets.emergentagent.com/job_relaxed-margulis-6/artifacts/smbxltnn_shay.png",
  },
  {
    id: 3,
    quote: "Overall amazing, attentive to detail, family friendly, patient. Even with a child with physical disabilities, Brittany has made sure that she was comfortable and we got the best experience ever. Makes us feel right at home each and every time!",
    author: "Kristin",
    type: "Family Client",
    image: "https://customer-assets.emergentagent.com/job_relaxed-margulis-6/artifacts/4i2yfifr_kristin.png",
  },
];

const TestimonialsSection = ({ isVisible }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section
      id="testimonials"
      className="py-24 lg:py-32 bg-[#F5F2EB]"
      data-testid="testimonials-section"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div
          className={`text-center mb-16 ${
            isVisible ? "animate-fade-in-up" : "opacity-0"
          }`}
        >
          <p className="overline text-[#C8A99C] mb-4">Testimonials</p>
          <h2 className="font-heading text-4xl lg:text-5xl font-light tracking-tight text-[#2C2A28] mb-6">
            Kind Words
          </h2>
          <div className="section-divider mx-auto" />
        </div>

        {/* Testimonial Carousel */}
        <div
          className={`relative ${
            isVisible ? "animate-fade-in-up animation-delay-200" : "opacity-0"
          }`}
        >
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Image */}
            <div className="relative h-[400px] lg:h-[500px]">
              <img
                src={testimonials[currentIndex].image}
                alt={`${testimonials[currentIndex].author}'s session`}
                className="w-full h-full object-cover transition-opacity duration-500"
              />
              <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-[#E2CCC2] -z-10" />
            </div>

            {/* Quote */}
            <div className="relative">
              <Quote size={48} className="text-[#E2CCC2] mb-6" />
              
              <blockquote className="font-heading text-xl lg:text-2xl italic text-[#2C2A28] leading-relaxed mb-8">
                "{testimonials[currentIndex].quote}"
              </blockquote>
              
              <div className="mb-8">
                <p className="font-body font-medium text-[#2C2A28]">
                  — {testimonials[currentIndex].author}
                </p>
                <p className="font-body text-sm text-[#5C5A56]">
                  {testimonials[currentIndex].type}
                </p>
              </div>

              {/* Navigation */}
              <div className="flex items-center gap-4">
                <button
                  onClick={prevTestimonial}
                  className="w-12 h-12 flex items-center justify-center border border-[#E8E4DD] text-[#5C5A56] hover:border-[#2C2A28] hover:text-[#2C2A28] transition-all"
                  data-testid="testimonial-prev"
                >
                  <ChevronLeft size={20} />
                </button>
                <button
                  onClick={nextTestimonial}
                  className="w-12 h-12 flex items-center justify-center border border-[#E8E4DD] text-[#5C5A56] hover:border-[#2C2A28] hover:text-[#2C2A28] transition-all"
                  data-testid="testimonial-next"
                >
                  <ChevronRight size={20} />
                </button>
                
                {/* Dots */}
                <div className="flex gap-2 ml-4">
                  {testimonials.map((_, idx) => (
                    <button
                      key={idx}
                      onClick={() => setCurrentIndex(idx)}
                      className={`w-2 h-2 rounded-full transition-all ${
                        idx === currentIndex
                          ? "bg-[#C8A99C] w-6"
                          : "bg-[#E8E4DD]"
                      }`}
                      data-testid={`testimonial-dot-${idx}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
